const _ = require('lodash')

// Regex copied from previous implementation
// Pipes remain in char class to maintain compatibility. Might be a bug
const HEX_COLOR_PATTERN = '#(([0-9|a-f|A-F]){3}){1,2}'

/**
 * @param {*} content
 * @returns {string}
 */
const parens = content => `(${content})`

/**
 * @param {*} content
 * @returns {string}
 */
const wholeString = content => `^${content}$`

/**
 * @param {*} content
 * @returns {string}
 */
const wholeStringParens = content => wholeString(parens(content))

/**
 * @param {*} c
 * @returns {string}
 */
const caseInsensitiveChar = c => `[${_.toUpper(c)}${_.toLower(c)}]`

/**
 * @param {*} word
 */
const caseInsensitiveWord = word => _(word).split('').map(caseInsensitiveChar).join('')

/**
 * @param {*} pattern
 * @param {*} options
 * @returns {*}
 */
const patternSchema = (pattern, {nullable = false} = {}) => ({
    type: nullable ? ['string', 'null'] : 'string',
    pattern
})

// Converted from code to regex
const createRgbaColorPattern = () => {
    const zeroTo255 = '(0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]'
    const num = parens(zeroTo255)
    const numAfterComma = `,${num}`
    const optionalCommaWithAlphaColor = '(,0*(0?\\.\\d+|0|1))?'
    const parts = [num, numAfterComma, numAfterComma, optionalCommaWithAlphaColor]
    return parts.join('')
}

// Converted from code to regex
const createColorPattern = () => {
    const themeColor = 'color_([0-9]{1,2}|100)'
    const themeColorCurly = `\\{${themeColor}\\}` // Regex copied from previous implementation
    const themeColorSquare = `\\[${themeColor}\\]`
    const parts = [createRgbaColorPattern(), themeColor, themeColorCurly, themeColorSquare, HEX_COLOR_PATTERN]
    const content = _(parts).map(parens).join('|')
    const surroundedContent = wholeStringParens(content)
    return `^$|${surroundedContent}`
}

const createBorderPattern = () => {
    const size = '(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})' // Regex copied from previous implementation
    const styleWords = _('solid dashed dotted double groove inset none outset ridge')
        .split(' ')
        .map(caseInsensitiveWord)
        .join('|')
    const style = `${parens(styleWords)}{0,1}[\\s]*` // Regex copied from previous implementation

    // Regex copied from previous implementation, except for the border color at the end.
    // It was added since it's the default value in many cases, and the default values must be accepted.
    const color = '([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?'

    const all = [size, style, color].join('')
    return `^$|${wholeString(all)}`
}

// Not a whole string to maintain compatibility (i.e. not surrounded by ^$). Might be a bug
// Regex copied from previous implementation
const uriSchema = patternSchema('[-a-zA-Z0-9@:%_\\+.~#?&//=]{2,256}\\.[a-z]{2,4}\\b(\\/[-a-zA-Z0-9@:%_\\+.~#?&//=]*)?')

// Converted from code to regex
// Intent: 0-4 numbers are allowed (inclusive)
// If there's one number it doesn't need units, but it can have them.
// If a number is non zero it needs units
// Implementation:
// Empty string
// Or 1-4 numbers with units
// Or number
//
// This regex does not comply with standard css rules, it only aims to mimic the pre-existing validation code.
// For example, "0.1" without a unit (px|em) will be accepted, which is invalid css.
const numberWithUnitOrZero = '(\\d+(.\\d+)?(em|px)|0(.0+)?)'
const permissiveNumber = '\\d*(.\\d+)?'
const paddingAndRadius = patternSchema(
    `^$|^${permissiveNumber}$|^${numberWithUnitOrZero}( +${numberWithUnitOrZero}){0,3}$`
)

// Regex copied from previous implementation
// Pipes remain in char class to maintain compatibility. Might be a bug
const theme = patternSchema('^[\\/\\-|0-9|a-z|A-Z]*$')
const cssMeasure = patternSchema('^\\d+(.\\d+)?(em|px)?$')
const cssMeasureWithUnit = patternSchema('^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$')

const createFormatsSchema = () => ({
    color: patternSchema(createColorPattern()),
    nullableColor: patternSchema(wholeStringParens(createColorPattern()), {nullable: true}),
    hexColor: patternSchema(wholeStringParens(HEX_COLOR_PATTERN)),
    nullableHexColor: patternSchema(wholeStringParens(HEX_COLOR_PATTERN), {nullable: true}),
    numeric: patternSchema('^\\d+$'),
    uri: uriSchema,
    border: patternSchema(createBorderPattern()),
    nullableBorder: patternSchema(createBorderPattern(), {nullable: true}),
    padding: paddingAndRadius,
    radius: paddingAndRadius,
    webThemeUrl: theme,
    themeUrl: theme,
    // Place holders for currently unimplemented font formats
    font: {type: ['string']},
    nullableFont: {type: ['string', 'null']},
    cssMeasure,
    cssMeasureWithUnit
})

module.exports = {
    createFormatsSchema
}
